import { financialsRowKinds } from "../types";

import { CurrencyCellRenderer } from "./CurrencyCellRenderer";
import { DollarSavingsCellRenderer } from "./DollarSavingsCellRenderer";
import { PremiumCellRenderer } from "./PremiumCellRenderer";
import { VarianceCellRenderer } from "./VarianceCellRenderer";

import type { FinancialsRow, FinancialsRowKind } from "../types";
import type { ICellRendererParams } from "ag-grid-community";

type RendererComponent = React.ComponentType<
  ICellRendererParams<FinancialsRow>
>;

const RENDERER_BY_KIND: Partial<Record<FinancialsRowKind, RendererComponent>> =
  {
    [financialsRowKinds.ANNUAL_PREMIUM]:
      PremiumCellRenderer as RendererComponent,
    [financialsRowKinds.TOTAL_ANNUAL_PREMIUM]:
      CurrencyCellRenderer as RendererComponent,
    [financialsRowKinds.VARIANCE]: VarianceCellRenderer as RendererComponent,
    [financialsRowKinds.TOTAL_VARIANCE]:
      VarianceCellRenderer as RendererComponent,
    [financialsRowKinds.DOLLAR_SAVINGS]:
      DollarSavingsCellRenderer as RendererComponent,
    [financialsRowKinds.TOTAL_DOLLAR_SAVINGS]:
      DollarSavingsCellRenderer as RendererComponent,
    [financialsRowKinds.TOTAL_CREDITS]:
      CurrencyCellRenderer as RendererComponent,
    [financialsRowKinds.TOTAL_PREMIUM_WITH_CREDITS]:
      CurrencyCellRenderer as RendererComponent,
  };

export const financialsCellRendererSelector = (
  params: ICellRendererParams<FinancialsRow>,
): { component: RendererComponent } | undefined => {
  if (!params.data) return undefined;

  const component = RENDERER_BY_KIND[params.data.kind];

  return component ? { component } : undefined;
};
